<div class="container-fluid m-0 py-1">
  <div class="row">
    <div class="col-24">
      <div
        class="content-box"
        *ngIf="!userData?.isLoading"
        [class.px-0]="menuItem?.menuType === menuTypes.ACCOUNT_SELECT"
      >
        <ng-container [ngSwitch]="menuItem?.menuType">
          <ng-container *ngSwitchCase="menuTypes.PRODUCTS">
            <shrd-pf-ui-product-menu-links [menuItems]="menuItem?.childList" [menuTitle]="menuItem.title" />
            <hr shrdUicHr />
            <shrd-pf-ui-view-categories-link />
          </ng-container>
          <shrd-pf-ui-user-account-links *ngSwitchCase="menuTypes.USER_PROFILE" [links]="userProfileLinks$ | async" />
          <shrd-pf-ui-user-account-links *ngSwitchCase="menuTypes.DOCUMENTS" [links]="documentsLinks$ | async" />
          <shrd-pf-ui-user-account-links *ngSwitchCase="menuTypes.FAVS" [links]="favoritesLinks$ | async" />
          <shrd-pf-ui-user-account-links *ngSwitchCase="menuTypes.TOOLS" [links]="tpmLinks$ | async" />
          <shrd-pf-ui-header-user-select
            *ngSwitchCase="menuTypes.ACCOUNT_SELECT"
            [accounts]="userData.accounts"
            [selectedAccountId]="userData.selectedAccount?.originId"
            (accountChanged)="accountChanged.emit($event)"
          />
          <shrd-pf-ft-select-language *ngSwitchCase="menuTypes.LANG" />
          <shrd-pf-ft-select-currency *ngSwitchCase="menuTypes.CURRENCY" />
          <shrd-pf-ft-contact-body *ngSwitchCase="menuTypes.CONTACT" [userData]="userData" class="mt-n1" />
          <shrd-pf-ui-editorial-menu-links
            *ngSwitchDefault
            [menuItems]="menuItem?.childList"
            [menuTitle]="menuItem.title"
          />
        </ng-container>
      </div>
    </div>
  </div>
</div>
